import React from 'react'
import { Route,Routes } from 'react-router-dom'
import ProductDetails from '../Components/ProductDetails'
import ProductPage from '../Components/ProductPage'

function AllRoutes() {
  return (
    <div>
        <Routes>
            <Route path="/" element={<ProductPage/>}/>
            <Route path="/product/:id" element={<ProductDetails/>}/>
        </Routes>
    </div>
  )
}

export default AllRoutes